import type { StateCreator } from 'zustand';
import type { Stats } from '../types';
import { statsApi } from '../services/statsApi';

export interface StatsSlice {
  stats: Stats | null;
  statsLoading: boolean;
  fetchStats: () => Promise<void>;
}

export const createStatsSlice: StateCreator<StatsSlice> = (set) => ({
  stats: null,
  statsLoading: false,

  fetchStats: async () => {
    set({ statsLoading: true });
    try {
      const stats = await statsApi.get();
      set({ stats, statsLoading: false });
    } catch {
      set({ statsLoading: false });
    }
  },
});
